module.exports = __webpack_public_path__ + "static/img/5056_phase_function_Paper_Points.66d5e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5056_phase_function_Paper_Points.png
// module id = 3rS0
// module chunks = 0